module.exports = __webpack_public_path__ + "media/media/logos/windows-5e3f6880605235394f89fb8f82d06d7b.png";